const hasJSONContent = response => {
  const contentType = response.headers.get('Content-Type', '')
  const contentLength = response.headers.get('Content-Length')
  return (
    contentType && contentLength &&
    contentType.startsWith('application/json') &&
    parseInt(contentLength, 10) > 0
  )
}

const parseResponse = async (component, response, logout401 = true) => {
  if (response.status >= 400) {
    if (response.status === 401 && logout401) {
      await component.$store.dispatch('user/logOut')
      if (!['user.login', 'user.register', 'user.password_reset', 'user.password_reset_token', 'notfound'].includes(component.$router.currentRoute.name)) {
        await component.$router.push({name: 'user.login'})
      }
    }
    let err = {status: response.status, url: response.url}
    if (hasJSONContent(response)) {
      err = {...err, ...await response.json()}
    } else {
      err.error = 'Something went wrong.'
    }
    throw err
  }

  if (hasJSONContent(response)) {
    return await response.json()
  }
}

const request = async (caller, url, method, extras = {}, isJson = true, logout401) => {
  let csrfToken = caller.$cookies.get('csrftoken')
  if (!csrfToken) {
    await fetch(
      `${process.env.VUE_APP_API_BASE}/api/users/csrf-token/`,
      {
        method: 'post',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
  }
  const headers = {
    'Accept': 'application/json',
    'X-CSRFToken': caller.$cookies.get('csrftoken'),
    'X-Requested-With': 'XMLHttpRequest'
  }
  if (isJson) {
    headers['Content-Type'] = 'application/json'
  }
  let response = await fetch(
    `${process.env.VUE_APP_API_BASE}${url}`,
    {
      method,
      credentials: 'include',
      headers,
      ...extras
    }
  )
  return parseResponse(caller, response, logout401)
}

export default {
  data() {
    return {
      errors: [],
      loading: false
    }
  },
  computed: {
    hasError() {
      return this.errors.length > 0
    }
  },
  created() {
    if (this.load !== undefined) {
      this.load()
    }
  },
  watch: {
    '$route': function () {
      if (this.load !== undefined) {
        this.load()
      }
    }
  },
  methods: {
    async request() {
      return request(this, arguments)
    },
    async delete(url, data, logout401) {
      return request(this, url, 'DELETE', {body: JSON.stringify(data)}, true, logout401)
    },
    async get(url) {
      return request(this, url, 'GET')
    },
    async patch(url, data) {
      return request(this, url, 'PATCH', {body: JSON.stringify(data)})
    },
    async post(url, data = {}) {
      return request(this, url, 'POST', {body: JSON.stringify(data)})
    },
    async postForm(url, body) {
      return request(this, url, 'POST', {body}, false)
    },
    async put(url, data) {
      return request(this, url, 'PUT', {body: JSON.stringify(data)})
    },
    async withLoading(fn, thing = 'loading') {
      this[thing] = true
      try {
        return await fn()
      } finally {
        this[thing] = false
      }
    },
    navigate(location, event = null) {
      if (event !== null) {
        event.preventDefault()
      }
      if (location !== this.$router.currentRoute.name) {
        this.$router.push({name: location})
      }
    },
    resolve(page, params = {}) {
      return this.$router.resolve({name: page, params}).route.path
    },
    catchApiError(err, reThrow = true, variableName = 'errors') {
      if (typeof err.error === 'object') {
        for (const key in err.error) {
          for (const errorMessage of err.error[key]) {
            this[variableName].push(`${key.charAt(0).toUpperCase() + key.slice(1)}: ${errorMessage}`)
          }
        }
      } else {
        this[variableName] = [err.error]
      }
      if (reThrow) {
        throw err
      }
    }
  }
}
